var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 10.5625C20.3125 8.6231 19.5421 6.76314 18.1707 5.39178C16.7994 4.02042 14.9394 3.25 13 3.25C11.0606 3.25 9.20064 4.02042 7.82928 5.39178C6.45792 6.76314 5.6875 8.6231 5.6875 10.5625C5.6875 13.5623 8.08763 17.472 13 22.1553C17.9124 17.472 20.3125 13.5623 20.3125 10.5625ZM13 24.375C7.04112 18.9589 4.0625 14.3536 4.0625 10.5625C4.0625 8.19213 5.00413 5.91884 6.68023 4.24273C8.35634 2.56663 10.6296 1.625 13 1.625C15.3704 1.625 17.6437 2.56663 19.3198 4.24273C20.9959 5.91884 21.9375 8.19213 21.9375 10.5625C21.9375 14.3536 18.9589 18.9589 13 24.375Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13C13.6465 13 14.2665 12.7432 14.7236 12.2861C15.1807 11.829 15.4375 11.209 15.4375 10.5625C15.4375 9.91603 15.1807 9.29605 14.7236 8.83893C14.2665 8.38181 13.6465 8.125 13 8.125C12.3535 8.125 11.7335 8.38181 11.2764 8.83893C10.8193 9.29605 10.5625 9.91603 10.5625 10.5625C10.5625 11.209 10.8193 11.829 11.2764 12.2861C11.7335 12.7432 12.3535 13 13 13ZM13 14.625C11.9226 14.625 10.8892 14.197 10.1274 13.4351C9.36551 12.6733 8.9375 11.6399 8.9375 10.5625C8.9375 9.48506 9.36551 8.45175 10.1274 7.68988C10.8892 6.92801 11.9226 6.5 13 6.5C14.0774 6.5 15.1108 6.92801 15.8726 7.68988C16.6345 8.45175 17.0625 9.48506 17.0625 10.5625C17.0625 11.6399 16.6345 12.6733 15.8726 13.4351C15.1108 14.197 14.0774 14.625 13 14.625Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.45013088a4104effba6541a3bf89eefc.svg";
export { ForwardRef as ReactComponent };